import Container, { Props } from './Container'
import ArrowLeftIcon from '@components/Icons/ArrowLeftIcon'
import { useTranslation } from '@i18n'
import Link from 'next/link'

function PrevButton(props: Props) {
  const { href, rel } = props
  const { t } = useTranslation('search')

  const children = (
    <Container rel={rel}>
      <ArrowLeftIcon />
      <span>{t('prevPage')}</span>
    </Container>
  )

  if (!href) return children

  return (
    <Link href={href} passHref>
      {children}
    </Link>
  )
}

export default PrevButton
